import React, { PropsWithChildren, useEffect, useState } from 'react';

import Video from './Video';
import Wrapper from './Wrapper';
import { loadScriptOnce } from './utils';

type Props = {
  autoPlay?: boolean;
  /** Display in a popover (aka "lightbox", aka "modal") */
  popover?: boolean;
  /** Title to show below the video in the popover */
  popoverCaption?: string;
  /** Wistia video ID */
  wistiaID: string;
};

export default function WistiaVideo(props: PropsWithChildren<Props>) {
  const { children } = props;

  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await loadScriptOnce('https://fast.wistia.com/assets/external/E-v1.js');
        setIsScriptLoaded(true);
      } catch {
        setIsScriptLoaded(false);
      }
    })();
  }, []);

  if (!isScriptLoaded) {
    return null;
  }

  const video = <Video {...props} />;

  return children ? video : <Wrapper>{video}</Wrapper>;
}
